import type { CrehanaTFunction } from '@crehana/i18n';

const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const AUTH_PAGES_PAGE_KEY = 'login';

export const validations = {
  required: (t: CrehanaTFunction) => ({
    value: true,
    message: t('INPUT_REQUIRED', { defaultValue: 'Campo requerido' }),
  }),
  maxLength: (t: CrehanaTFunction) => ({
    value: 50,
    message: t('VALIDATE_MAX_PASSWORD', {
      defaultValue: 'Tu contraseña debe de tener máximo 6 caracteres',
    }),
  }),
  minLength: (t: CrehanaTFunction) => ({
    value: 6,
    message: t('VALIDATE_MIN_PASSWORD', {
      defaultValue: 'Tu contraseña debe de tener al menos 6 caracteres',
    }),
  }),
  email: (t: CrehanaTFunction) => ({
    value: REGEX_EMAIL,
    message: t('VALIDATE_FORMAT_EMAIL', {
      defaultValue: 'Por favor, ingresa un email válido.',
    }),
  }),
};

export const EVENTS = {
  REGISTER: 'AUTH__REGISTER',
  LOGIN: 'AUTH__LOGIN',
  AUTH_SOCIAL: 'auth_social',
  SIGNUP_FORM_BUTTON_CLICK: 'Click Signup Button',
  BLOG_LIKE_BUTTON_CLICK: 'BLOG_LIKE_BUTTON_CLICK',
  BLOG_GO_TO_RECOMMENDED_ARTICLE: 'BLOG_GO_TO_RECOMMENDED_ARTICLE',
};
